import { FunctionalComponent, h } from 'preact';

export const SatelliteIcon: FunctionalComponent<{fill?: string}> = (props) => {
	const {fill = '#595959'} = props;

	return (
		<svg width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g clipPath="url(#SatelliteIcon)">
				<path
					d="M9.844 14.406c.238.238.198.647-.096.806a6.62 6.62 0 01-7.811-1.15 6.617 6.617 0 01-1.15-7.809A.484.484 0 011.22 6c.14 0 .273.055.372.154l3.77 3.774.685-.684c-.021-.081-.05-.156-.05-.244a1 1 0 111 1c-.088 0-.163-.028-.244-.05l-.684.684 3.774 3.772zm-2.143-.022L1.618 8.3a5.151 5.151 0 001.381 4.703A5.08 5.08 0 006.614 14.5c.365 0 .73-.04 1.087-.116zM16 9.478a.507.507 0 01-.51.522h-.5a.499.499 0 01-.493-.484c-.213-4.316-3.7-7.772-8.017-8.013a.498.498 0 01-.481-.493v-.5A.508.508 0 016.52 0C11.625.266 15.73 4.372 16 9.478zm-3.003-.006a.505.505 0 01-.507.525h-.505a.503.503 0 01-.494-.475C11.266 6.853 9.144 4.685 6.48 4.5a.498.498 0 01-.481-.493v-.5A.5.5 0 016.523 3a7.032 7.032 0 016.474 6.472z"
					fill={fill}/>
			</g>
			<defs>
				<clipPath id="SatelliteIcon">
					<path fill="#fff" d="M0 0h16v16H0z"/>
				</clipPath>
			</defs>
		</svg>
	);
};
